import axios from 'axios';
import { Conversation, ChatBody } from '@/types/interfaces';

export function createChatBody(
  question: string,
  sessionId: string,
  interactionId: string,
  conversation: Conversation[],
  promptQuery?: string
): ChatBody {
  // only map the conversation if it has an answer
  const history = conversation
    .filter((item) => item.answer) // filter out conversations without an answer
    .map((item) => {
      return {
        human: item.question,
        ai: item.answer
      };
    });

  return {
    channel: 'search',
    system: 'answers',
    sub_system: promptQuery || 'answers',
    question,
    session_id: sessionId,
    interaction_id: interactionId,
    history,
    suggest_follow_on_questions: false,
    suggestions_use_answer: true
  };
}

export async function fetchSuggestedQuestions({
  question,
  answer,
  session_id,
  interaction_id,
  headers = {}
}: {
  question: string;
  answer: string;
  session_id: string;
  interaction_id: string;
  headers?: { [key: string]: string };
}): Promise<string[]> {
  const sqBody = {
    question,
    answer,
    session_id,
    interaction_id
  };
  const response = await axios.post(
    '/api/answers/lbbd_answer_service_suggest_questions',
    sqBody,
    { headers }
  );
  if (response.data.suggested_questions) {
    return response.data.suggested_questions.slice(0, 4);
  }
  return [];
}
